import { FC } from 'react';
import { useReportsDataHealthStore } from 'pages/ReportsPage/store/reportsDataHealth.store';
import {
  DataLockedOverlay,
  DataLockedCard,
  DataLockedSpinner,
  DataLockedTitle,
  DataLockedBody,
} from 'pages/ReportsPage/components/DataLockedView/DataLockedView.styled';

export const DataLockedView: FC<{ x: number }> = ({ x }) => {
  const isDataLocked = useReportsDataHealthStore((s) => s.isDataLocked);

  if (!isDataLocked) return null;

  return (
    <DataLockedOverlay x={x} isPendingApproval={false} role="status" aria-live="polite">
      <DataLockedCard>
        <DataLockedSpinner />
        <DataLockedTitle>Refreshing your dashboard</DataLockedTitle>
        <DataLockedBody>
          Data is being refreshed to reflect the latest activity - back automatically in a few
          minutes.
        </DataLockedBody>
      </DataLockedCard>
    </DataLockedOverlay>
  );
};
